/* jshint eqnull:true */
define (['jquery', 'wcs.input-validator'], function ($, inputValidator){
	/* This function returns true if the parameter exits in the URL,
	 * looking also in the hash tail, otherwise it returns false */
	function hasURLParam(url, param) {
        url = getFullUrl(url);

        if (url.search(param) > -1) {
			return true;
		}

		return false;
	}

	/* This function returns the value of the requested URL parameter.
	 * If the parameter is not found in the URL, then 0 is returned. */
	function getURLParam(url, param) {
		var value = 0,
			paramIndex = -1;
		param = encodeURIComponent(param);

		if (url) {
			paramIndex = url.indexOf(param);

			if (paramIndex > -1) {
				url = url.substring(paramIndex);

				if (url.indexOf ('&') > -1) {
					url = url.substring(0, url.indexOf ('&'));
				}

				value = url.substring(url.indexOf ('=') + 1);

                // If the param is the last one in the query param list - the hash will be present, so it needs to be removed
                if (value.indexOf('#') > -1) {
                    // Stripping everything after the hash value
                    value = value.split('#')[0];
                }
			}
		}

		return value;
	}

	/* This function returns an object containing all the query parameter from the provided URL.
	 * If there is no query parameter, then an empty object is returned. */
	function getAllURLParams(url) {
        var valueArray = {},
			queryString = url.split('?')[1];

        if (url && queryString) {
			queryString = queryString.split('#')[0];
			var queryTokenArray = queryString.split('&');

            $.each(queryTokenArray, function(key, value) {
            	var tokenArray = value.split('=');
                valueArray[tokenArray[0]] = tokenArray[1];
            });
        }

		return valueArray;
	}

	/* This function updates or adds a parameter to the URL.
	 * This is a non-destructive function meaning the URL pass to
	 * it will not be modified. Instead it will return a new updated
	 * URL. */
	function setURLParam(url, param, value) {
        url = getFullUrl(url);

		var updatedURL = '',
			pair = '';
        param = encodeURIComponent(param);
        value = encodeURIComponent(value);

		if (url.indexOf(param) > -1) {
			pair = param + '=' + value;
            var paramRegex = new RegExp(param + "=([^&#]*)", "gi"); //In case of searchTerm we want to match non words characters also
			updatedURL = url.replace(paramRegex, pair);
		} else {
			pair = (url.indexOf ('?') < 0) ? '?' : '&';
			pair += param + '=' + value;
			updatedURL = url + pair;
		}

		return updatedURL;
	}

    /* This function returns the hash part of URL (hash symbol included).
     * If the URL is not provided, current URL is used as default.
     * If the hash part is missing an empty string is returned. */
    function getHash(url) {
    	var urlHash = '';

        if (!url) {
            return location.hash;
        }

        var hashIndex = url.indexOf('#');
    	if (hashIndex > -1) {
            return url.substring(hashIndex);
		}

        return urlHash;
    }

    /* This function updates url bringing into query paramenters all the parameters
     * from the url's hash tail. */
    function getBaseUrl(url) {
        url = getFullUrl(url);

        return removeHash(url).split('?')[0];
    }

    /* This function return the input url if it's given, if not
     * return the current full url. */
    function getFullUrl(url) {
        if (!url) {
            return location.href;
        }
        return url;
    }

    /* This function updates the value of a given parameters and returns the updated url.
     * Not only the proper query parameter is updated, but the parameter contained in
     * the hash tail as well. */
	function updateQueryStringParameter(uri, key, value, addAsHash) {
        var re = new RegExp('([?&#])' + key + '=.*?(&|#|$)', 'gi'),
			separator = '';

		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		}
		// No matches
		if(addAsHash) {
			separator = uri.indexOf('#') !== -1 ? '&' : '#';
		} else {
			separator = uri.indexOf('?') !== -1 ? '&' : '?';
			if( uri.indexOf('#') !== -1 ){
				uri = uri.replace(/#.*/, '');
			}
		}

		return uri + separator + key + "=" + value;
	}

    /* This function updates the value of a given set of parameters and returns the updated url.
     * Not only the proper query parameters are updated, but the parameters contained in
     * the hash tail as well. */
	function setMultipleURLParams(params, addAsHash, url) {
		url = getFullUrl(url);

		Object.keys(params).forEach(function(param) {
			url = updateQueryStringParameter(url, param, params[param], addAsHash);
		});

		return url;
	}

    /* This function updates url bringing into query paramenters all the parameters
     * from the url's hash tail. */
    function setMultipleURLParamsFromHash(url) {
    	url = getFullUrl(url);

        var urlHash = getHash(url),
			baseUrl = getBaseUrl(url),
            urlQueryParametersObject = getAllURLParams(url),
			hashQueryParametersObject = getAllURLParams('?' + urlHash.substring(1));
        	$.extend(urlQueryParametersObject, hashQueryParametersObject);

        var queryString = Object.keys(urlQueryParametersObject).map(function(key) {
            return key + '=' + urlQueryParametersObject[key];
        }).join('&');

        return baseUrl + '?' + queryString + urlHash;
    }

	/* Must pass a url and it will return a decoded url without the url parameter. */
	function removeURLParam (url, param){
		var paramIndex = url.indexOf (param),
			urlBase = "",
			urlTail = "",
			URL = url;
		if (paramIndex > -1){
			urlBase = url.substring (0, paramIndex);
			urlTail = url.substring (paramIndex);
			paramIndex = urlTail.indexOf ('&');
			if (paramIndex > -1){
				urlTail = urlTail.substring (paramIndex + 1);
				URL = urlBase + urlTail;
			}
			else{
				if (urlBase.lastIndexOf('&') === urlBase.length-1) {
					urlBase = urlBase.substring(0,urlBase.lastIndexOf('&'));
				}
				URL = urlBase;
			}
		}
		return URL;
	}

	/**
	 * Sort facet param to avoid duplicate cache entry for same result when user select multiple facet in different order
	 * @param {*} param 
	 */
	function  sortFacetParam(param) {
		newParam = param.sort(function(a, b) {
			if (a < b) return -1;
			if (a > b) return 1;
			return 0;
		});
		return newParam;
	}

	/**
		* Loop through items affected in response, compose property keys for each item,
		* add key and value to params
		* @param {object, object, object}
		* data - Object containing presourcing error flags
		* params - array containing params that passed to URL
		* key - array containing param keys required
		*/

	function addItemPreSourcingParams(data, params, key) {
		var presourcingInputValidator = new inputValidator();

		for (var k = 0; k < data.catentryNumber; k++) {
			for(var m = 0; m < key.length; m++) {
				var catKey = key[m]+'_'+k,
				catValue = data[catKey];
				if (!presourcingInputValidator.isEmpty(catValue)) {
					params[catKey] = catValue;
				}
			}
		}

		return params;
	}

	/**
	 * Navigates to the specified URL with the specified parameters
	 * @param {string} url - Base URL
	 * @param {object|string} params - Query string parameters
	 * @param {Location} [location=window.location] - Location object. Defaults to window.location, but can be overridden to navigate a different frame.
	 */
	function navigateWithParams(url, params, location) {
		// Handle params argument according to its type
		if (typeof params === 'object') {
			params = $.param(params);
			url = url + '?' + params;
		}
		else if (typeof params === 'string' && params.length > 0) {
			url = url + '?' + params;
		}
		// Use location object if specified or default to window.location
		if (typeof location !== 'object') {
			location = window.location;
		}
		location.href = url;
	}

	function isDisabledButton(target){
    	if(target!=null && target.hasClass('disabled')){
    		return true;
    	}
    	return false;
	}

	function enableButton(target){
    	if(target!=null && target.hasClass('disabled'))
    		target.removeClass('disabled');
	}

	function disableButton(target){
    	if(target!=null && !target.hasClass('disabled'))
    		target.addClass('disabled');
	}

	function getParamFromHash(param){
	    var re = new RegExp("#(.*[?&]|)" + param + "=([^&]+)(&|$)");
	    var match = window.location.hash.match(re);
	    return (match && match[2] ? match[2] : "");
	}

    /* Remove the hash tail from a url. */
	function removeHash(url) {
		url = getFullUrl(url);

        var hashIndex = url.indexOf('#'),
            noHashUrl = url;

        if (hashIndex > -1) {
            noHashUrl = url.substring (0, hashIndex);
        }

        return noHashUrl;
	}

	var waitForFinalEvent = (function () {
	  var timers = {};
	  return function (callback, ms, uniqueId) {
	    if (!uniqueId) {
	      uniqueId = "Don't call this twice without a uniqueId";
	    }
	    if (timers[uniqueId]) {
	      clearTimeout (timers[uniqueId]);
	    }
	    timers[uniqueId] = setTimeout(callback, ms);
	  };
	})();

	function checkPOBOXAddress(addressLine){
		if (addressLine == null || addressLine === '') {
			return false;
		}

		var pattern;
		if( typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('address::poBoxValidationRegex') !== 'undefined'){
			pattern = new RegExp(WCS_CONFIG.get('address::poBoxValidationRegex'),'i');
		} else {
			pattern = new RegExp('(P\\.? *?O\\.?\\s?|post\\s+office )+Box\\s','i');
		}

		if (addressLine.match(pattern)) {
	        return true;
		}

	    return false;
	}

	// Search Widget More link
	function showSearchWidgetMoreLink(){
		var searchWidget = $('#br-related-searches-widget').length ;
		if (searchWidget > 0){
		var numOfWidgetLinks = $('#br-related-searches-widget a').length ;
			if (numOfWidgetLinks > 5) {
				var moreText = LANG_SEARCH_WIDGET.SEARCH_WIDGET_MORE;
				var $moreLink = $('<a id="more" href="javascript:void(0)" >'+moreText+'</a>');
				$moreLink.on('click', function() {
					$('#more').hide();
					$( "div.br-related-query" ).last().show();
				});
				if($('#more').length === 0) {
				     $( "div.br-related-query" ).last().hide().after($moreLink );
				}
			}
		}
	}

	/**
	 * Interrupts the transitions on the elements so that
	 * we can toggle states without triggering CSS animations:
	 *   1. Removes transitions
	 *   2. Runs callback function
	 *   3. Reapplies transitions
	 *
	 * @param JQuery Object $elements to toggle
	 * @param callback function executed between removing and reapplying
	 **/
	function interruptTransitions($elements, callback) {
		// Callback must be a function
		if(callback && typeof callback !== 'function') {
			throw callback + ' is not a function.';
		}
		// $elements must be a JQuery object
		if(typeof($elements) !== 'object' || !($elements.jquery)) {
			throw $elements + ' is not a JQuery object.';
		}
		// $elements must have an array of objects
		if($elements.length < 1) {
			throw $elements + ' is empty.';
		}

		var cache = [];
		$elements.each(function(idx, el) {
			cache[idx] = el.style.transition;
			el.style.transition = '';
		});

		if(callback) callback();

		$elements.each(function(idx, el) {
			el.style.transition = cache[idx];
		});
	}

	// Changes XML to JSON
	function xmlToJson(xml) {
		// Create the return object
		var obj = {};

		if (xml.nodeType === 1) { // element
			var numAttributes = xml.attributes.length;
			// do attributes
			if (numAttributes > 0) {
			obj.attributes = {};
				for (var j = 0; j < numAttributes; j++) {
					var attribute = xml.attributes.item(j);
					obj.attributes[attribute.nodeName] = attribute.nodeValue;
				}
			}
		} else if (xml.nodeType === 3) { // text
			obj = xml.nodeValue;
		}

		// do children
		if (xml.hasChildNodes()) {
			for(var i = 0; i < xml.childNodes.length; i++) {
				var item = xml.childNodes.item(i);
				var nodeName = item.nodeName;
				if (typeof(obj[nodeName]) == "undefined") {
					obj[nodeName] = xmlToJson(item);
				} else {
					if (typeof(obj[nodeName].push) == "undefined") {
						var old = obj[nodeName];
						obj[nodeName] = [];
						obj[nodeName].push(old);
					}
					obj[nodeName].push(xmlToJson(item));
				}
			}
		}
		return obj;
	}
	var deviceMap =  [
	                    {
	                        "dType": "ios",
	                        "qString": "ipad"},
	                    {
	                        "dType": "ios",
	                        "qString": "ipod"},
	                    {
	                        "dType": "ios",
	                        "qString": "iphone"},
	                    {
	                        "dType": "android",
	                        "qString": "android"},
	                    {
	                        "dType": "wp7",
	                        "qString": "windows phone"},
	                    {
	                        "dType": "w8",
	                        "qString": "windows nt 6.2"}
	                ];
	// return device type using above map.
    function getDeviceType(){
            var ua, i, l, dType;
            ua = navigator.userAgent.toLowerCase();
            i = 0;
            l = deviceMap.length;
            dType = "default";
            // search the user-agent string for qString and when one is found return the associated device type
            for (i; i < l; i++) {
                if (ua.indexOf(deviceMap[i].qString) >= 0) {
                    dType = deviceMap[i].dType;
                    break;
                }
            }
            return dType;
    }

	/**
	 * Returns the width/height of a hidden element. Elements with no display will always return 0 for height and width
	 * so this utility can be used to get its size while it remains hidden. Children will also not have a size if a
	 * parent is hidden, so an optional element can be passed in to target the hidden parent. Either the element or parent
	 * will receive display with no visibility, the size will be captured, and then the display will be removed.
	 * @param {jQuery Object} $el - Element to get size of
	 * @param {jQuery Object} $hiddenParent - Optional element to use in case a parent is hidden
	 */
	function getHiddenElementSize($el, $hiddenParent) {
		var _styles = {
			'hide': {
				'display': '',
				'left': '',
				'position': '',
				'visibility': ''
			},
			'display': {
				'display':'block',
				'left': '-999em',
				'position': 'absolute',
				'visibility':'hidden'
			}
		};

		// give display to the hidden parent if provided, otherwise use the targeted element
		var _displayElement = $hiddenParent ? $hiddenParent : $el;

		// add temporary display to hidden element
		_displayElement.css(_styles.display);

		// get the size of targeted element
		var _size = {
			height: $el.outerHeight(),
			width: $el.outerWidth()
		};

		// remove temporary display from hidden element
		_displayElement.css(_styles.hide);

		return _size;
	}

    // Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
	}

	// Wait for element to exist in the DOM.
  function elementLoaded(el, cb) {
    if ($(el).length) {
      // Element is now loaded.
      cb($(el));
    } else {
      // Repeat every 500ms.
      setTimeout(function() {
        elementLoaded(el, cb);
      }, 500);
    }
  }

	function cleanString(string) {
		var temp = document.createElement('div');
		temp.innerHTML = string;
		return temp.textContent;
	}

	function displayNotificationToScreenReaders(el) {
		$(el).attr('aria-live','assertive');
	}

	/**
     * This function is to implement
     * See More / See Less toggle
	 * @param {*} el (link, button...)
     * @param {*} container
     */
    function seeMoreLessToggle($el, $container){
        $el.on('click', function () {
            if($container.length){
                if($container.hasClass('expanded')){
                    $container.removeClass('expanded');
                    $(this).text($container.data('show-more'));
                }else{
                    $container.addClass('expanded');
                    $(this).text($container.data('show-less'));
                }
            }
        });
    }

    function getFullscreenElement() {
    	return (
			document.fullscreenElement ||
			document.mozFullScreenElement ||
			document.webkitFullscreenElement ||
			document.msFullscreenElement
		);
	}

	function getVideoBufferedTime(videoElement) {
		return videoElement.buffered.length && videoElement.buffered.end(0) || 0;
	}

	function decodeHTML(html) {
		var doc = new DOMParser().parseFromString(html, "text/html");
		return doc.documentElement.textContent;
	}

	function hexToRgb(hex) {
		var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hex = hex.replace(shorthandRegex, function(m, r, g, b) {
			return r + r + g + g + b + b;
		});

		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	}

	function luminance(r, g, b) {
		var a = [r, g, b].map(function (v) {
			v /= 255;
			return v <= 0.03928 ?
				v / 12.92 :
				Math.pow( (v + 0.055) / 1.055, 2.4 );
		});
		return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
	}

	/**
	 * This function returns the color which have higher contrast ratio with the background - either checkMarkHex1 or checkMarkHex2
	 */
	function compareContrast(backgroundHex, checkMarkHex1, checkMarkHex2) {
		var backR = hexToRgb(backgroundHex);
		var check1R = hexToRgb(checkMarkHex1);
		var check2R = hexToRgb(checkMarkHex2);

		var backL = luminance(backR.r, backR.g, backR.b);
		var check1L = luminance(check1R.r, check1R.g, check1R.b);
		var check2L = luminance(check2R.r, check2R.g, check2R.b);

		if(Math.abs(backL - check1L) > Math.abs(backL - check2L)){
			return checkMarkHex1;
		}
		return checkMarkHex2;
	}

	/**
	 * This function returns parameterized messages
	 * 
	 * @param {string} message - string message with parameters like {0}
	 * @param {array} params - array of parameters
	 */
	function formatMessage (message, params) {
		for (var i = 0; i < params.length; i++) {
			message = message.replace('{'+i+'}', params[i]);
		}
		return message;
	}

	/**
	 * This function returns percentages as a negative integer to reflect mark-down
	 * 
	 * @param {*} priceNumeric 
	 * @param {*} listPriceNumeric 
	 * @returns 
	 */	
	function calculateDiscount(priceNumeric, listPriceNumeric) {
		var discountPercentage = Math.round((( priceNumeric - listPriceNumeric ) * 100 / listPriceNumeric )) || 0;
		return discountPercentage;
	}

	/**
	 * Sets the text content of a specific text node inside the parent element
	 * instead of exchanging the whole existing content with the new text
	 * which is currently achieved with .text( text ) jquery function
	 *
	 * @param {jQuery Object} $parent - The parent element that contains the text node to be edited
	 * @param {jQuery Object} text - The new text value for the first text node found
	 */
	function setTextNodeValueOfElement($parent, text) {
		if (!$parent || !$parent.contents || text == null) {
			return;
		}
		var textNodes = $parent.contents()
			.filter(function (i, nextNode) {
				return nextNode.nodeType === 3;
			});
		var selectedTextNode;
		if (!textNodes.length) {
			selectedTextNode = document.createTextNode('');
			$parent.prepend(selectedTextNode);
		} else {
			var nonEmptyTextNodes = textNodes.filter(function (i, nextNode) {
				return nextNode.textContent && nextNode.textContent.trim().length;
			});
			selectedTextNode = nonEmptyTextNodes.length ? nonEmptyTextNodes[0] : textNodes[0];
		}
		selectedTextNode.textContent = text;
	}

	return{
		setURLParam: setURLParam,
		setMultipleURLParams: setMultipleURLParams,
        setMultipleURLParamsFromHash: setMultipleURLParamsFromHash,
		getURLParam: getURLParam,
        getAllURLParams: getAllURLParams,
		hasURLParam: hasURLParam,
		removeURLParam: removeURLParam,
		addItemPreSourcingParams: addItemPreSourcingParams,
		navigateWithParams: navigateWithParams,
		isDisabledButton: isDisabledButton,
		enableButton: enableButton,
		disableButton: disableButton,
		getParamFromHash: getParamFromHash,
        getHash: getHash,
        getBaseUrl: getBaseUrl,
        getFullUrl: getFullUrl,
        removeHash: removeHash,
		checkPOBOXAddress: checkPOBOXAddress,
		showSearchWidgetMoreLink: showSearchWidgetMoreLink,
		interruptTransitions: interruptTransitions,
		xmlToJson: xmlToJson,
		waitForFinalEvent: waitForFinalEvent,
		getDeviceType: getDeviceType,
		getHiddenElementSize: getHiddenElementSize,
		debounce: debounce,
		elementLoaded: elementLoaded,
		cleanString: cleanString,
		displayNotificationToScreenReaders: displayNotificationToScreenReaders,
		seeMoreLessToggle: seeMoreLessToggle,
		getFullscreenElement: getFullscreenElement,
		getVideoBufferedTime: getVideoBufferedTime,
		decodeHTML: decodeHTML,
		compareContrast: compareContrast,
		formatMessage: formatMessage,
		calculateDiscount: calculateDiscount,
		sortFacetParam: sortFacetParam,
		setTextNodeValueOfElement: setTextNodeValueOfElement
	};
});
